import all from './all';
import users from './users';
import annonces from './annonces';

const ApiController = {
    all,
    users,
    annonces,
}
export default ApiController